export function trimTemplateText(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export function normalizeTemplateLine(value: string): string {
  return value.replace(/\r/g, "").trim();
}

export function parseMarkdownSections(rawSource: string): Map<string, string> {
  const normalized = rawSource.replace(/\r/g, "");
  const sectionMatches = Array.from(normalized.matchAll(/^##\s+(.+)$/gm));
  const sections = new Map<string, string>();

  sectionMatches.forEach((match, index) => {
    const title = normalizeTemplateLine(match[1]).toLowerCase();
    const start = match.index! + match[0].length;
    const end = index + 1 < sectionMatches.length ? sectionMatches[index + 1].index! : normalized.length;
    sections.set(title, normalized.slice(start, end).trim());
  });

  return sections;
}

export function parseBulletListSection(value: string): string[] {
  return value
    .split("\n")
    .map((line) => line.replace(/^[-*]\s*/, "").trim())
    .filter(Boolean);
}

export function escapeTemplateValue(value: string): string {
  return value.trim();
}

export function bulletBlock(items: string[], fallback: string): string {
  return items.length > 0 ? items.map((item) => `- ${escapeTemplateValue(item)}`).join("\n") : `- ${fallback}`;
}
